var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"loader"},[_c('b-spinner',{staticStyle:{"width":"50px","height":"50px"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }